// App.js
import React from "react";
import { useLocation } from "react-router-dom";

import { ErrorBoundry } from "./components/ErrorBoundry";
import { PageTabTitle, TopNavBar, AuthenticatedUser, CreateWrapper } from "./components";

const AuthenticatedRoute = ({ authenticate, title, element, useTitleId }) => {
  const location = useLocation();

  if (authenticate) {
    return (
      <AuthenticatedUser location={location}>
        <PageTabTitle title={title} useTitleId={useTitleId} />
        <TopNavBar />
        <CreateWrapper>
          <ErrorBoundry>
            {element}
          </ErrorBoundry>
        </CreateWrapper>
      </AuthenticatedUser>
    );
  }

  return (
    <>
      <PageTabTitle title={title} />
      {element}
    </>
  );
};

export default AuthenticatedRoute;
